<template>
    <a-config-provider :theme="{ token: { controlHeight: 50 } }">
    <div class="search_form" :class="{ 'search_form--no-selects': !selects.length }">
        <div class="search_form_input">
            <a-input
                :value="contractNum"
                placeholder="Поиск..."
                class="search_form_input_item"
                @update:value="$emit('update:contractNum', $event)"
                @change="$emit('change', $event)"
            >
                <template #prefix>
                    <search-outlined style="color: #007BFF;"/>
                </template>
            </a-input>
        </div>
        <a-divider />
        <p v-if="dateLabel" class="search_form_date_label">{{ dateLabel }}</p>
        <a-select
            v-for="select in selects"
            :key="select.key"
            :value="select.value"
            :placeholder="select.placeholder"
            :options="select.options"
            class="search_form_select"
            popup-class-name="search_form_select_dropdown"
            @update:value="select.onUpdate"
            @change="select.onChange"
            allow-clear
        />
        <div class="search_form_date">
            <p>C</p>
            <a-config-provider :locale="ruRu">
                <a-input-group compact class="search_form_date_item" >
                    <a-input
                        style="width: 40px; text-align: center"
                        disabled
                    >
                        <template #prefix>
                            <calendar-outlined />
                        </template>
                    </a-input>
                    <a-date-picker
                        format="DD.MM.YYYY"
                        show-today="false"
                        :suffix-icon="null"
                        :value="startDate"
                        style="width: calc(100% - 40px)"
                        placeholder="Выберите дату"
                        allow-clear
                        :input-read-only="false"
                        @update:value="$emit('update:startDate', $event)"
                        @change="$emit('changeStartDate', $event)"/>
                </a-input-group>
            </a-config-provider>
            <p>по</p>
            <a-config-provider :locale="ruRu">
                <a-input-group compact class="search_form_date_item">
                    <a-input
                        style="width: 40px; text-align: center"
                        disabled
                    >
                        <template #prefix>
                            <calendar-outlined />
                        </template>
                    </a-input>
                    <a-date-picker
                        :suffix-icon="null"
                        :value="endDate"
                        style="width: calc(100% - 40px)"
                        placeholder="Выберите дату"
                        allow-clear
                        :input-read-only="false"
                        @update:value="$emit('update:endDate', $event)"
                        @change="$emit('changeEndDate', $event)"
                        format="DD.MM.YYYY"
                    />
                </a-input-group>
            </a-config-provider>
        </div>
        <a-button @click="$emit('search')" :loading="loading">{{ searchButtonText }}</a-button>
    </div>
    </a-config-provider>
</template>

<script>
import { Input, DatePicker, Divider, Button, Select, ConfigProvider } from 'ant-design-vue'
import ruRu from 'ant-design-vue/es/locale/ru_RU'
import { SearchOutlined, CalendarOutlined } from '@ant-design/icons-vue'

export default {
    name: 'PersonalAccountSearchForm',
    components: {
        AInput: Input,
        ADatePicker: DatePicker,
        ADivider: Divider,
        AButton: Button,
        ASelect: Select,
        AConfigProvider: ConfigProvider,
        SearchOutlined,
        CalendarOutlined,
    },
    props: {
        contractNum: {
            type: String,
            default: null
        },
        startDate: {
            default: null
        },
        endDate: {
            default: null
        },
        selects: {
            type: Array,
            default: () => []
        },
        dateLabel: {
            type: String,
            default: null
        },
        loading: {
            type: Boolean,
            default: false
        },
        searchButtonText: {
            type: String,
            default: 'Поиск'
        }
    },
    emits: [
        'update:contractNum',
        'change',
        'update:startDate',
        'changeStartDate',
        'update:endDate',
        'changeEndDate',
        'search'
    ],
    data() {
        return { ruRu }
    }
}
</script>

<style lang="scss" scoped>
@mixin fontStyle ($family,$style,$weight, $size, $lheight, $color) {
    font-family: $family;
    font-style: normal;
    font-weight: $weight;
    font-size: $size;
    line-height: $lheight;
    color: $color;
}
.search_form{
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
    row-gap: 15px;
    &_input{
        width: 100%;
    }
    &_date_label{
        width: 100%;
        @include fontStyle(Roboto, normal, 400, 14px, 31px, #373737);
    }
    &_date{
        display: flex;
        width: 38%;
        justify-content: space-between;
        height: 50px;
        align-items: center;
        gap: 15px;
        margin-top: 20px;
        @media (max-width: 1024px) {
            margin-top: 0;
        }
        p{
            @include fontStyle(Roboto, normal, 400, 20px, 31px, #373737);
						margin-bottom: 0 !important;
        }
        &_item{
            background: #fff;
            border-radius: 8px;
            width: 100%;
            span{
                background: #fff;
                color: #007BFF;
                border: none;
                font-size: 18px;
            }
            .ant-picker{
                background: #fff;
                border: none;
                height: 50px;
            }
            .ant-picker-focused{
                box-shadow: none;
            }
        }

        @media (max-width: 1024px) {
            width: 100%;
        }

        @media (max-width: 575px) {
            flex-direction: column;
            align-items: stretch;
            height: auto;
            gap: 8px;

            p {
							margin-bottom: 0 !important;
            }
        }
    }
    &_select{
        width: 31%;
        max-height: 50px;
        height: 100%;

        @media (max-width: 1024px) {
            width: 48%;
        }

        @media (max-width: 575px) {
            width: 100%;
        }
    }
    button{
        @include fontStyle(Roboto, normal, 400, 18px, 31px, #373737);
        height: 50px !important;
        border: none;
        background-color: #007BFF;
        color: #fff;
        width: 19%;
        margin-top: 20px;
				transition: all .2s;
				&:hover {
					color: #fff;
					background-color: #0059B9;
				}

        @media (max-width: 1024px) {
            width: 100%;
            margin-top: 8px;
        }
    }
    ::v-deep(.ant-divider) {
        margin: 6px 0;
    }
    &--no-selects{
        .search_form_date{
            width: 50%;
            margin-top: 0;
        }
        button{
            margin-top: 0;
        }
    }
}
::v-deep(.search_form){
    .search_form_input_item{
        height: 50px !important;
        border: none;
        .anticon-search{
            font-size: 18px;
        }
    }
    .search_form_input_item:focus{
        box-shadow: none;
    }
    .search_form_select{
        position: relative;
        .ant-select-selector{
            border: none;
            height: auto !important;
            min-height: 50px !important;
            input{
                padding: 24px 0;
                display: flex;
                align-items: center;
            }
            .ant-select-selection-placeholder{
                display: flex;
                align-items: center;
            }
            .ant-select-selection-item{
                display: flex;
                align-items: center;
                white-space: normal;
                word-break: break-word;
                line-height: 1.3;
            }
        }
        .ant-select-arrow{
            top: 0;
            bottom: 0;
            margin-top: 0;
            transform: none;
            height: auto;
            display: flex;
            align-items: center;
        }
    }
}

.search_form_select_dropdown{
    .ant-select-item{
        height: auto;
    }
    .ant-select-item-option-content{
        white-space: normal;
        word-break: break-word;
        overflow: visible;
        text-overflow: unset;
        line-height: 1.3;
    }
}
</style>